import { cyrb64Hash } from "@/lib/crypto.utils"
import { InteractionSchema, type TContact, type TInteraction } from "@/schemas/contacts"
import type { TPhoneStatus } from "@/schemas/user.schema"
import { observable } from "@legendapp/state"

interface IChatData {
  unreadChats: Record<TContact["ContactPersonId"], number> // For now number is just 0 or 1
  interactions: Record<TContact["ContactPersonId"], Record<string, TInteraction>> // TInteraction["RingId"]
  sortedInteractions: Record<TContact["ContactPersonId"], Array<string>> // TInteraction["RingId"]
  contacts: Record<string, TContact>
  liveCalls: Array<{
    contactId: TContact["ContactPersonId"]
    ringId: TInteraction["RingId"]
    status: TPhoneStatus
    direction: TInteraction["Direction"]
  }>
  chats: Array<TContact["ContactPersonId"]>
  chatLastInteraction: Record<TContact["ContactPersonId"], TInteraction>
  searchChats: Array<TContact["ContactPersonId"]>
  filteredChats: Array<TContact["ContactPersonId"]>
  _internal: {
    // This allow us to have a map with only unique keys
    // Like a Set, but with the ability to have a key-value pair
    chatsMap: Record<TContact["ContactPersonId"], boolean>
    searchChatsMap: Record<TContact["ContactPersonId"], boolean>
    liveCallsMap: Record<TContact["ContactPersonId"], boolean>

    // Having a map of sortedInteractions allows us to determine if an interaction
    // has already been added to the sorted array in O(1) time
    sortedInteractionsMap: Record<TContact["ContactPersonId"], Record<string, boolean>>
  }
}

const initialState: IChatData = {
  unreadChats: {},
  interactions: {},
  sortedInteractions: {},
  contacts: {},
  liveCalls: [],
  chats: [],
  chatLastInteraction: {},
  searchChats: [],
  filteredChats: [],
  _internal: {
    chatsMap: {},
    searchChatsMap: {},
    liveCallsMap: {},
    sortedInteractionsMap: {},
  },
}

interface IChatStore extends IChatData {}

export const chatStore$ = observable<IChatStore>({
  ...initialState,
})

export function extractInteractionFromContact(contact: TContact): TInteraction {
  const interaction = InteractionSchema.parse(contact)
  interaction.Hash = cyrb64Hash(JSON.stringify(interaction))

  return interaction
}
